import jobTitlesTypeApi from 'Api/axios/job-title-types-api';
import { useState, useEffect } from 'react';
import type { JobTitleTypeFilterI, JobTitleTypeI } from 'types';

interface Props {
  init?: boolean;
}

const useJobTitlesTypeApi = ({ init = false }: Props = {}) => {
  const [data, setData] = useState<Array<JobTitleTypeI>>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchJobTitlesType = async (filters: JobTitleTypeFilterI = {}) => {
    setLoading(true);
    const response = await jobTitlesTypeApi.readAll(filters);
    setData(response.data ?? []);
    setLoading(false);
    setError(response.error);
  };

  useEffect(() => {
    if (init) {
      fetchJobTitlesType();
    }
  }, [init]);

  return {
    data,
    loading,
    error,
    fetchJobTitlesType,
  };
};

export default useJobTitlesTypeApi;
